import { useSelector } from 'react-redux';

import {
  modalTypes,
  selectModalEntity,
  type TSCreateModalParams,
} from '../../ducks/modal';
import BuildingInsightsDrawer from '../BuildingInsightsDrawer';
import DeleteSavedFilterModal from '../BuildingInsightsSavedQueries/DeleteSavedFilterModal';
import SaveFilterModalForm from '../BuildingInsightsSavedQueries/SaveFilterModalForm';
import ConfirmModal from '../ConfirmModal';
import OpportunityDetailModal from '../OpportunityDetailModal';
import AddLabelsPopup from '../OpportunityFeed/AddLabelsPopup';
import CreateBatchPopup from '../OpportunityFeed/CreateBatchPopup';
import CreateOrEditOpportunity from '../OpportunityFeed/CreateOrEditOpportunity';
import SiteConfigurationModal from '../SiteConfigurationModal/index';
import OptEnergyStarModal from '../OptEnergyStarModal';
import EnableSitesModal from '../EnergyStarModals/EnableSitesModal';
import OnboardingModal from '../EnergyStarModals/OnboardingModal';

type TSProps = TSCreateModalParams;

const MODAL_COMPONENTS = {
  [modalTypes.MODAL_SITE_CONFIGURATION]: SiteConfigurationModal,
  [modalTypes.MODAL_QUERY_BUILDER]: BuildingInsightsDrawer,
  [modalTypes.MODAL_OPPORTUNITY_DETAIL]: OpportunityDetailModal,
  [modalTypes.MODAL_OPPORTUNITY_CREATE_OR_EDIT_OPPORTUNITY]:
    CreateOrEditOpportunity,
  [modalTypes.MODAL_OPPORTUNITY_CREATE_BATCH]: CreateBatchPopup,
  [modalTypes.MODAL_OPPORTUNITY_ADD_LABELS]: AddLabelsPopup,
  [modalTypes.MODAL_CONFIRM_NAVIGATION]: ConfirmModal,
  [modalTypes.MODAL_SAVE_FILTER]: SaveFilterModalForm,
  [modalTypes.MODAL_DELETE_SAVED_FILTER]: DeleteSavedFilterModal,
  [modalTypes.OPT_ENERGY_STAR]: OptEnergyStarModal,
  [modalTypes.ENABLE_SITES_ENERGY_STAR]: EnableSitesModal,
  [modalTypes.ONBOARDING_ENERGY_STAR]: OnboardingModal,
};

const ModalContainer = () => {
  const { modalType, modalProps }: TSProps = useSelector(selectModalEntity);

  if (!modalType) {
    return null;
  }

  const CurrentModal = MODAL_COMPONENTS[modalType];
  if (!CurrentModal) {
    return null;
  }

  return <CurrentModal {...modalProps} />;
};

export default ModalContainer;
